import api from '../../api_embassy';
export default {
    namespaced: true,
    state: {

    },
    getters: {

    },
    mutations: {
    },
    actions: {
        Save_TermsAndConditions({ }, termcondFlg) {
            return new Promise((resolve, reject) => {
                api().post("api/v1/TermsAndConditions/Save_TermsAndConditions", {
                    "termcondFlg": termcondFlg,
                    "AdmApplicantId": this.getters["Auth_embassy/getSelectedAdmApplicantId"],
                    "AdmAppRegHistoryId": this.getters["Auth_embassy/getSelectedAdmAppRegHistoryId"],
                })
                    .then(resp => {
                        if (resp.status == "200") {
                            localStorage.setItem('isSubmitted', true);
                            resolve({ status: true })
                        }
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
    }
}
